import { ContentReducerCreator } from '../types';

const clearUploadedJobsReducer = (create: ContentReducerCreator) => {
  return create.reducer((state) => {
    state.uploadJobs = [];
  });
};

export default clearUploadedJobsReducer;
